import React from "react";
import { cardCls, labelCls } from "./tokens";

const STATUS_MAP = {
  draft: { label: "Draft", cls: "bg-onedesk-bg text-onedesk-textSecondary border-onedesk-border" },
  submitted: { label: "Submitted", cls: "bg-onedesk-primary/10 text-onedesk-primary border-onedesk-primary/20" },
  in_progress: { label: "In Progress", cls: "bg-onedesk-warning/10 text-onedesk-warning border-onedesk-warning/20" },
  ready: { label: "Ready", cls: "bg-onedesk-success/10 text-onedesk-success border-onedesk-success/20" },
  delivered: { label: "Delivered", cls: "bg-onedesk-success/15 text-onedesk-success border-onedesk-success/30" },
  on_hold: { label: "On Hold", cls: "bg-onedesk-bg text-onedesk-textSecondary border-onedesk-border" },
};

/**
 * StatusBadge — sale / task lifecycle indicator.
 * status: draft | submitted | in_progress | ready | delivered | on_hold
 */
export function StatusBadge({ status, children, testId }) {
  const meta = STATUS_MAP[status] || {
    label: children || status,
    cls: "bg-onedesk-bg text-onedesk-textSecondary border-onedesk-border",
  };
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-od-input border px-3 py-1 text-xs font-bold uppercase tracking-wider ${meta.cls}`}
    >
      {children || meta.label}
    </span>
  );
}

const SLA_MAP = {
  on_track: { label: "On Track", dot: "#10B981", cls: "bg-onedesk-success/10 text-onedesk-success border-onedesk-success/30" },
  at_risk: { label: "At Risk", dot: "#F59E0B", cls: "bg-onedesk-warning/10 text-onedesk-warning border-onedesk-warning/30" },
  delayed: { label: "Delayed", dot: "#EF4444", cls: "bg-onedesk-danger/10 text-onedesk-danger border-onedesk-danger/30" },
  on_hold: { label: "On Hold", dot: "#0F172A", cls: "bg-onedesk-primary/10 text-onedesk-primary border-onedesk-primary/20" },
  paused: { label: "Paused", dot: "#64748B", cls: "bg-onedesk-bg text-onedesk-textSecondary border-onedesk-border" },
};

/**
 * SLABadge — SLA pill with status + remaining time.
 * status: on_track | at_risk | delayed | on_hold | paused
 */
export function SLABadge({ status, remaining, testId }) {
  const meta = SLA_MAP[status] || SLA_MAP.paused;
  return (
    <span
      data-testid={testId || `sla-badge-${status}`}
      className={`inline-flex items-center gap-2 rounded-od-input border px-3 py-1 text-xs font-bold ${meta.cls}`}
    >
      <span
        aria-hidden="true"
        className="inline-block h-2 w-2 rounded-full"
        style={{ backgroundColor: meta.dot }}
      />
      <span className="uppercase tracking-wider">{meta.label}</span>
      {remaining && (
        <span className="font-medium normal-case tracking-normal opacity-80">
          · {remaining}
        </span>
      )}
    </span>
  );
}

export { STATUS_MAP, SLA_MAP, labelCls, cardCls };
